export default "__VITE_ASSET__BnZujyII__"